/**
 * @file RbtStaffingMiamiFl.jsx
 * @description Agency market page at /rbt-staffing-miami-fl. Miami-Dade / Broward page; Miami is ABAcases' home market. Layout lives in
 *   AgencyMarketPage; this file owns the SEO head, breadcrumb JSON-LD and the
 *   page's copy/visual config (agencyMarket.miami.* keys).
 * @module components/RbtStaffingMiamiFl
 */
import { useTranslation } from "react-i18next";
import { agencyChips } from "./AgencyVisuals";
import AgencyMarketPage from "./AgencyMarketPage";
import { useBreadcrumbJsonLd, useSiteSchema } from "../lib/seoSchema";
import { usePageSeo } from "../lib/seo";

export default function RbtStaffingMiamiFl({ onNavigate }) {
  const { t } = useTranslation();
  const k = (key) => t(`agencyMarket.miami.${key}`);

  usePageSeo({
    title: "RBT Staffing in Miami, FL | Reach ABA Providers with ABAcases",
    description: "RBT staffing in Miami, FL? Post your ABA case on ABAcases and reach verified local RBTs, BTs, BCBAs, and BCaBAs by schedule, setting, and credential.",
    canonical: "/rbt-staffing-miami-fl",
  });
  useSiteSchema(); // global Organization + WebSite
  useBreadcrumbJsonLd("bc-jsonld-rbt-staffing-miami-fl", [
    { name: "Home", url: "/" },
    { name: "For ABA Agencies", url: "/aba-agencies" },
    { name: "RBT Staffing in Miami, FL", url: "/rbt-staffing-miami-fl" },
  ]);

  return (
    <AgencyMarketPage
      onNavigate={onNavigate}
      source="rbt_staffing_miami_fl"
      pagePath="/rbt-staffing-miami-fl/"
      market="miami"
      crumb={k("title")}
      badge={k("badge")}
      title={k("title")}
      subtitle={k("subtitle")}
      chips={agencyChips(t)}
      coverageTitle={k("coverageTitle")}
      body={k("body")}
      visual={{ type: "rings", center: "Miami", towns: [{ name: "Fort Lauderdale", angle: -85, outer: true }, { name: "Hialeah", angle: -125 }, { name: "Doral", angle: -175 }, { name: "Miami Beach", angle: -15 }, { name: "Coral Gables", angle: 150 }, { name: "Kendall", angle: 130, outer: true }, { name: "Homestead", angle: 95, outer: true }] }}
      area={k("area")}
      links={[
        { to: "aba-staffing-florida", label: t("agencyMarket.linkFlorida") },
        { to: "rbt-jobs-miami-fl", label: t("agencyMarket.linkJobsMiami") },
        { to: "aba-provider-waitlist", label: t("agencyMarket.linkWaitlist") },
      ]}
    />
  );
}
